import { render, staticRenderFns } from "./LiveChat.vue?vue&type=template&id=0e7029cd&"
import script from "./LiveChat.vue?vue&type=script&lang=js&"
export * from "./LiveChat.vue?vue&type=script&lang=js&"
import style0 from "./LiveChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7029cd')) {
      api.createRecord('0e7029cd', component.options)
    } else {
      api.reload('0e7029cd', component.options)
    }
    module.hot.accept("./LiveChat.vue?vue&type=template&id=0e7029cd&", function () {
      api.rerender('0e7029cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/LiveChat.vue"
export default component.exports